import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    eyebrow?: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    description,
    align = 'left',
    className
}): ReactNode => {
    return (
        <div
            className={cn(
                'flex flex-col gap-3',
                align === 'center' && 'items-center text-center',
                className
            )}
        >
            {eyebrow && (
                <span className='text-xs font-semibold uppercase tracking-[0.18em] text-primary'>
                    {eyebrow}
                </span>
            )}

            <h2 className='font-heading text-3xl font-semibold tracking-tight text-foreground sm:text-4xl'>
                {title}
            </h2>

            {description && (
                <p
                    className={cn(
                        'max-w-2xl text-base leading-relaxed text-muted-foreground',
                        align === 'center' && 'mx-auto'
                    )}
                >
                    {description}
                </p>
            )}
        </div>
    )
}
